import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { IndivalifeLogo } from '@/components/IndivalifeLogo';

const PublicProfile = () => {
  const { personalId } = useParams();
  const [profile, setProfile] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/profile/public/${personalId}`); setProfile(data);
      } catch { setErr(true); }
    })();
  }, [personalId]);

  if (err) return <div className="min-h-screen grid place-items-center text-sm text-[var(--bz-muted)]">Profile not found</div>;
  if (!profile) return <div className="min-h-screen grid place-items-center text-sm text-[var(--bz-muted)]">Loading…</div>;

  return (
    <div className="min-h-screen bg-[var(--bz-soft)] py-12 px-4">
      <div className="max-w-md mx-auto">
        <div className="flex items-center justify-center mb-6"><IndivalifeLogo size={40} withWordmark /></div>
        <Card className="p-6 bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] text-white">
          <div className="text-center">
            {profile.picture && <img src={profile.picture} alt={profile.name} className="h-24 w-24 rounded-full mx-auto border-2 border-white" />}
            <h1 className="text-2xl font-black display mt-3">{profile.name}</h1>
            {profile.nickname && <div className="text-sm opacity-80">aka {profile.nickname}</div>}
            {profile.personal_id && <div className="text-xs opacity-80 font-mono-bz mt-1">{profile.personal_id}</div>}
            {profile.rank === 'IR' && (
              <div className="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full bg-[var(--bz-orange)] text-white text-xs font-bold" data-testid="public-rank-badge">
                🏅 INDIVALIFE Retailer
              </div>
            )}
            {profile.bio && <p className="text-sm mt-3 opacity-90">{profile.bio}</p>}
          </div>
          <div className="border-t border-white/30 mt-4 pt-4 space-y-1 text-sm">
            {profile.phone && <div>📞 {profile.phone}</div>}
            {profile.email && <div>✉ {profile.email}</div>}
            {profile.town && <div>📍 {profile.town}</div>}
          </div>
          {profile.social_links && Object.values(profile.social_links).some(Boolean) && (
            <div className="border-t border-white/30 mt-3 pt-3 flex flex-wrap gap-2">
              {Object.entries(profile.social_links).filter(([k, v]) => v && k !== 'company_logo').map(([k, v]) => (
                <span key={k} className="bg-white/20 px-2 py-1 rounded-full text-xs capitalize">{k}: {v}</span>
              ))}
            </div>
          )}
        </Card>
        <div className="text-center text-xs text-[var(--bz-muted)] mt-4">Powered by INDIVALIFE</div>
      </div>
    </div>
  );
};

export default PublicProfile;
